import React from 'react';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import SEO from '../components/SEO';

const Home = ({ siteData }) => {
    return (
        <>
            <SEO
                title="Savana Ashlea | Art, Photography & Wellness"
                description="Creating beautiful moments through art, photography, and wellness. Explore stunning photography, meaningful artwork, and transformative yoga experiences."
                url="https://savanashlea.com/"
            />
            <div className="pt-16"> {/* Account for fixed navbar */}
                <HeroSection heroData={siteData?.hero} />
                <AboutSection aboutData={siteData?.about} />
            </div>
        </>
    );
};

export default Home;